import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface BookingPopupModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Cabana / picnic-table booking entry point.
 *
 * The Checkfront popup has been replaced by the first-party booking flow at
 * /book-now. This shim keeps every existing CTA call site working: opening it
 * simply routes the guest into the new flow.
 *
 * The original Checkfront popup is preserved at
 * src/components/booking-fallback/BookingPopupModal.tsx.
 */
export function BookingPopupModal({ open, onOpenChange }: BookingPopupModalProps) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    onOpenChange(false);
    navigate("/book-now");
  }, [open, onOpenChange, navigate]);

  return null;
}
